import {Injectable} from '@angular/core';
import {BaseApiService} from '../common/base-api.service';
import {HttpClient} from '@angular/common/http';
import {SettingsProviderService} from '../common/settings-provider.service';
import {Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends BaseApiService {
  privacyStatementLink: string;
  environmentSetting: string;

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'Settings');
  }
  getEnvironment(): Observable<any> {
    if (this.environmentSetting) {
      return of(this.environmentSetting);
    } else {
      return this.post<any>('GetEnvironment').pipe(switchMap(res => {
        this.environmentSetting = res;
        return of(this.environmentSetting);
      }));
    }
  }
  getPrivacyStatementUrl(): Observable<any> {
    if (this.privacyStatementLink) {
      return of(this.privacyStatementLink);
    } else {
      return this.post<any>('GetPrivacyStatementUrl').pipe(switchMap(res => {
        this.privacyStatementLink = res?.privacyStatementLink;
        return of(this.privacyStatementLink);
      }));
    }
  }

}
